import { ConsoleLogger, RegisteredLogger } from "../logger/index.js";
//#region src/base/MastraBase.ts
var MastraBase = class {
	component = RegisteredLogger.LLM;
	logger;
	name;
	#rawConfig;
	constructor({ component, name, rawConfig }) {
		this.component = component || RegisteredLogger.LLM;
		this.name = name;
		this.#rawConfig = rawConfig;
		this.logger = new ConsoleLogger({ name: `${this.component} - ${this.name}` });
	}
	/**
	* Returns the raw storage configuration this primitive was created from,
	* or undefined if it was created from code.
	*/
	toRawConfig() {
		return this.#rawConfig;
	}
	/**
	* Sets the raw storage configuration for this primitive.
	* @internal
	*/
	__setRawConfig(rawConfig) {
		this.#rawConfig = rawConfig;
	}
	/**
	* Set the logger for the agent
	* @param logger
	*/
	__setLogger(logger) {
		this.logger = "child" in logger && typeof logger.child === "function" ? logger.child({ component: this.component }) : logger;
	}
};
//#endregion
export { MastraBase };

//# sourceMappingURL=index.js.map